<template>
  <div class="login-body">
    <div class="login-wrapper">
      <div class="login-panel">


        <div class="login-form">

          <h2>{{$t("login.title")}}</h2>
          <div class="p-mt-4 p-mb-3">{{$t("login.message")}}</div>

          <InputText id="email" :placeholder="$t('login.email')" v-model="email" />
          <Password placeholder="Password" v-model="password" />
          <div class="field-checkbox">
            <Checkbox id="rememberMe" inputId="binary" v-model="checked" :binary="true" />
            <label for="rememberMe">Remember me</label>
          </div>

          <Button label="CONTINUE" type="button" @click="login" @keyup.enter="login"
            :disabled="!email || !password"></Button>
        </div>


      </div>

      <div class="login-image" style="background-image: url('assets/layout/images/login/login-image-cucina-futuro.jpg');"></div>

    </div>
  </div>
</template>

<script>
import LoginService from "../service/LoginService";
export default {
  data() {
    return {
      email: "",
      password: "",
      error: null,
      checked: false,
    };
  },
  created() {
    this.loginService = new LoginService();
  },
  methods: {
    login: async function () {
      this.error = null;
      this.loading = true;
      this.loginService
        .login(this.email, this.password)
        .then((data) => {
          //console.log(data);
          this.$store.commit("userdata/loginData", {
            email: this.email,
            ...data,
          });
          this.$store.dispatch("profile/loadMe");
          this.loading = false;
          this.$router.push({ name: "dashboard" });
        })
        .catch((error) => {
          this.loading = false;
          if (error.response) {
            console.log(error.response.data); // => the response payload
            this.error = error.response.data.error_description;
          } else {
            console.log(JSON.stringify(error));
          }
        });
    },
  },
};
</script>

<style scoped>
.login-body {
  font-family: Helvetica, sans-serif;
}

.login-wrapper {
  display: flex;
}

.login-panel {
  width: 100%;

}

.login-form {
  display: flex;
  align-items: center;
  flex-direction: column;
  min-width: 323px;
}

h2 {
  font-weight: 700;
}

.p-mt-4 {
  margin-top: 1.5rem;
}

.p-mb-3 {
  margin-bottom: 1rem;
}

.cursor {
  cursor: pointer;
}

.forgot-password {
  font-weight: 300;
  float: right;
}

.p-button {
  border-radius: 3px;
}

.p-m-4 {
  margin: 1.5rem;
}

.login-image {
  background-position: 100%;
  height: 100vh;
}
</style>
<style>

</style>